const uniqueId =(prefix?: string) => {
  const uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
  if (prefix) {
    return `${prefix}${uid}`
  }
  return uid;
}

export default uniqueId;const uniqueId =(prefix?: string) => {
  const uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
  if (prefix) {
    return `${prefix}${uid}`
  }
  return uid;
}

export default uniqueId;